export function initializeCalculatorStorage()
{
	const storage: {[key: string]: any} = {};

	return {
		get: function (section: string) {
			return storage[section];
		},
		update: function (section: string, data: any) {
			storage[section] = data;
		}
	};
}

export function initializePatientStorage()
{
	const storage = window.sessionStorage;
	const key = 'patient';

	return {
		get: function () {
			const state = storage.getItem(key)
			return state === null ? {} : JSON.parse(state);
		},
		update: function (data: any) {
			storage.setItem(key, JSON.stringify(data));
		}
	};
}
